import { useTranslation } from "react-i18next";
import { Button } from "components/buttons/Button";
import styles from "./index.module.scss";

export const SkipToContentLink = () => {
    const { t } = useTranslation();
    return (
        <Button
            href="#main-content"
            type="action"
            additionalClassName={styles["skip-to-content-link"]}
            tag="a"
        >
            {t("buttons:skip-to-main-content")}
        </Button>
    );
};
